import {Injectable} from '@angular/core';
import {BehaviorSubject, catchError, map, of, switchMap} from 'rxjs';
import {StorageService} from './storage.service';
import {PartyService} from "@portal/api/party-service";
import {SearchRequest} from "@portal/api/requests/search-request";
import {PartyLocationsService} from "@portal/api/party-locations-service";
import {CollaboratorsService} from "@portal/api/collaborators-service";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class DropdownDataService {
    private locationsData = new BehaviorSubject<any[]>([]);
    public readonly locationsData$ = this.locationsData.asObservable();

    // Collaborators
    private collaboratorsData = new BehaviorSubject<any[]>([]);
    public readonly collaboratorsData$ = this.collaboratorsData.asObservable();

    constructor(
        private _partiesService: PartyService,
        private _collaboratorsService: CollaboratorsService,
        private _partyLocationsService: PartyLocationsService,
        private _storageService: StorageService) {
    }

    getPartyLocations(offset = 0, limit = environment.defaultDropdownLimit, allOptions: any[] = []) {
        return this._partyLocationsService.listByParty({
            page: offset / limit,
            pageSize: limit,
            sortDirection: 0,
            sortField: 'name'
        } as SearchRequest).pipe(
            catchError(() => of({data: {items: [], totalItems: 0}})),
            switchMap(response => {
                const options = response.data.items.map(item => ({
                    label: item.name,
                    value: item.id.toString()
                }));
                const newAllOptions = allOptions.concat(options);
                this.locationsData.next(newAllOptions);
                if (newAllOptions.length < response.data.totalItems) {
                    return this.getPartyLocations(offset + limit, limit, newAllOptions);
                } else {
                    this.locationsData.next(newAllOptions);
                    return of(newAllOptions);
                }
            })
        );
    }

    getPartyCollaborators(offset = 0, limit = environment.defaultDropdownLimit, allOptions: any[] = []) {
        return this._collaboratorsService.listByParty({
            page: offset / limit,
            pageSize: limit,
            sortDirection: 0,
            sortField: 'name'
        } as SearchRequest).pipe(
            catchError(() => of({data: {items: [], totalItems: 0}})),
            switchMap(response => {
                const options = response.data.items.map(item => ({
                    label: item.name,
                    value: item.id.toString()
                }));
                const newAllOptions = allOptions.concat(options);
                this.collaboratorsData.next(newAllOptions);
                if (newAllOptions.length < response.data.totalItems) {
                    return this.getPartyCollaborators(offset + limit, limit, newAllOptions);
                } else {
                    this.collaboratorsData.next(newAllOptions);
                    return of(newAllOptions);
                }
            })
        );
    }
}
